export const ExtendedAccessRoleName = "extended_access"

export enum ExtendedAccessStatus {
	Available = "available",
	/** @lintignore */
	Unavailable = "unavailable",
	/** @lintignore */
	Active = "active",
	/** @lintignore */
	Expired = "expired",
}

export type ExtendedAccess = {
	status: ExtendedAccessStatus
	startedAt: string | null
	endsAt: string | null
}
